"use client";

import { ComponentProps } from "react";

type Props = ComponentProps<"div">;

export const AnalysisLayoutDesktopNavigationWrapper = ({ children }: Props) => {
  return (
    <>
      {/*
       * Note:
       * To make the navigation sticky, we need to define the height of the navigation.
       * In this case, we can set `h-min` so that the navigation can be sticky.
       * Referenced from https://youtu.be/8MaCTDkoVd8?t=778
       */}
      <div className="top-[var(--my-navbar-mask-height)] col-span-1 hidden h-min lg:block">
        {/*
         * NOTE:
         * To make the navigation scrollable when the screen is too small,
         * we need to define the height of the navigation.
         * Referenced from: https://stackoverflow.com/a/37755176
         */}
        <div className="space-y-6 overflow-y-auto scrollbar-hide">
          {children}
        </div>
      </div>
    </>
  );
};
